export const USER_SCROLL_CANCEL_EVENTS = ['wheel', 'touchstart', 'pointerdown'] as const;
